import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useState } from "react";
import DiseaseRiskPanel from "./diseaseRiskPanel.component";

const FieldMonitoring = ({ field, children }) => {
  const [tab, setTab] = useState(0);
  const [riskVisited, setRiskVisited] = useState(false);
  return <Box component="section" aria-label="Monitoraggio del terreno" sx={{ width: "100%", minWidth: 0 }}>
    <Typography component="h2" fontWeight={600} fontSize={20}>Monitoraggio</Typography>
    <Tabs value={tab} onChange={(_, value) => { setTab(value); if (value === 1) setRiskVisited(true); }} aria-label="Monitoraggio del terreno" sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}>
      <Tab id="field-measures-tab" aria-controls="field-measures-panel" label="Misure" sx={{ textTransform: "none" }} />
      <Tab id="field-risk-tab" aria-controls="field-risk-panel" label="Rischio fitosanitario" sx={{ textTransform: "none" }} />
    </Tabs>
    <Box id="field-measures-panel" role="tabpanel" aria-labelledby="field-measures-tab" hidden={tab !== 0}>
      <Box display="flex" flexDirection="column" gap={2}>{children}</Box>
    </Box>
    <Box id="field-risk-panel" role="tabpanel" aria-labelledby="field-risk-tab" hidden={tab !== 1}>
      {riskVisited && <DiseaseRiskPanel field={field} enabled={tab === 1} />}
    </Box>
  </Box>;
};

export default FieldMonitoring;
